export interface PolymarketMarketMeta {
	question: string;
	startDate: string | null;
	endDate: string | null;
}

// Public, unauthenticated, CORS-open -- safe to call directly from the browser.
const GAMMA_API_BASE = "https://gamma-api.polymarket.com";

export async function fetchPolymarketMarketMeta(
	conditionId: string,
): Promise<PolymarketMarketMeta | null> {
	const url = new URL("/markets", GAMMA_API_BASE);
	url.searchParams.set("condition_ids", conditionId);

	const response = await fetch(url.toString());
	if (!response.ok) return null;

	const body = (await response.json()) as Array<{
		question?: string;
		startDate?: string;
		endDate?: string;
	}>;
	const market = body[0];
	if (!market) return null;

	return {
		question: market.question ?? "",
		startDate: market.startDate ?? null,
		endDate: market.endDate ?? null,
	};
}
